<template>
    <section class="card detail-competences-section">
        <div class="section-header">
            <h3>{{ $trans("web_profile.detailed_competences") }}</h3>
            <EditButton :onClick="WebProfileStore.openEditDetailedCompetencesModal" />
        </div>

        <div class="competences-grid">
            <template
                v-for="comp in WebProfileStore.detailedCompetences"
                :key="comp.id"
            >
                <div class="profile-card-competencies-item">
                    <div class="title">
                        {{ comp.name }} /
                        <span class="title-duration">{{ comp.duration }}</span>
                    </div>
                    <ProgressBar
                        :percentage="comp.duration_percentage"
                        :tag-id="comp.id"
                    />
                </div>
            </template>
        </div>

        <EditDetailedCompetencesModal />
    </section>
</template>

<script>
import { mapStores } from "pinia";
import { useWebProfileStore } from "@/stores/WebProfileStore";
import EditButton from "./../Components/EditButton.vue";
import EditDetailedCompetencesModal from "./Modals/EditDetailedCompetencesModal.vue";
import ProgressBar from "./../Components/ProgressBar.vue";

export default {
    name: "DetailCompetencesSection",
    components: {
        EditDetailedCompetencesModal,
        ProgressBar,
        EditButton,
    },
    computed: {
        ...mapStores(useWebProfileStore),
    },
};
</script>

<style scoped>
.detail-competences-section {
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
h3 {
    margin: 0;
    font-size: 1.875rem;
    font-weight: 600;
}

.competences-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

.title {
    font-weight: 700;
    color: #000;
    margin-bottom: 8px;
    font-size: 16px;
}

.card {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    background-color: #fff;
}

.el-button {
    background-color: #41abc4;
    border-color: #41abc4;
}
</style>
